module.exports = __webpack_public_path__ + "img/img3.1fbb1ed9.svg";